import phoneImage from '../../assets/img/miespol-pantallla.jpg'
import { Box, styled } from '@mui/material';


const ModalContainerBox = styled(Box)(({ theme }) => ({
    backgroundImage: `url(${phoneImage})`, 
    backgroundSize: 'cover', 
    backgroundPosition: 'center',
    height: '625px', 
    width: '325px', 
    display: 'flex',
    marginTop: '5vh',
    marginLeft: '5vw',
    justifyContent: 'center',
    alignItems: 'center',
}));


export default ModalContainerBox;